import { processHtmlContent } from "../../helpers/processHtmlContent";

export const DocumentPreview = ({ html }) => {
  const processedHtml = processHtmlContent(html);

  const documentStyles = `
    <style>
      body { 
        padding: 20px; 
        font-family: "Times New Roman", Times, serif; 
        font-size: 12pt;
        color: #000;
        background-color: #fff;
      }
      
      /* Table Stylings */
      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 16pt;
        font-size: 12pt;
        page-break-inside: avoid;
      }
      
      table td, table th {
        padding: 8pt 12pt;
        vertical-align: top;
        border: 1px solid #333;
        word-wrap: break-word;
      }
      
      table th {
        background-color: #f5f5f5;
        font-weight: bold;
        text-align: left;
      }
      
      /* Specific styling for form tables */
      table tbody tr:nth-child(even) {
        background-color: #fafafa;
      }
      
      table tbody tr:hover {
        background-color: #f0f0f0;
      }
      
      /* Special styling for numbered paragraphs in tables */
      table td:first-child {
        width: 40px;
        text-align: center;
        font-weight: bold;
        background-color: #f8f8f8;
        border-right: 2px solid #333;
      }
      
      /* Style for form input areas */
      table td em {
        font-style: italic;
        color: #666;
      }
      
      /* Paragraph spacing within tables */
      table td p {
        margin: 0;
        padding: 0;
        line-height: 1.5;
      }
      
      table td p:not(:last-child) {
        margin-bottom: 8pt;
      }
      
      /* Headers and sections */
      h1, h2, h3, h4, h5, h6 {
        font-weight: bold;
        margin-top: 16pt;
        margin-bottom: 8pt;
        color: #000;
      }
      
      p {
        margin-bottom: 12pt;
        text-align: justify;
      }
      
      /* Section headings within document */
      p strong {
        font-weight: bold;
      }
      
      /* Checkbox styling (since they're removed by processHtmlContent) */
      input[type="checkbox"] {
        display: none;
      }
      
      /* Special table formatting for legal documents */
      .legal-table {
        border: 2px solid #000;
        background-color: #fff;
      }
      
      .legal-table td {
        border: 1px solid #000;
        padding: 6pt 10pt;
        background-color: #fff;
      }
      
      .legal-table th {
        border: 1px solid #000;
        background-color: #f0f0f0;
        font-weight: bold;
      }
      
      /* Responsive table wrapper */
      .table-responsive {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }
      
      /* Improved styling for numbered table cells */
      .legal-table td:first-child p {
        text-align: center;
        font-weight: bold;
        margin: 0;
      }
      
      /* Better spacing for form-like tables */
      .legal-table tbody tr:hover {
        background-color: #f8f8f8;
      }
      
      .legal-table tbody tr:hover td {
        background-color: #f8f8f8;
      }
      
      /* Enhanced readability for text within tables */
      .legal-table td p {
        line-height: 1.4;
        text-align: left;
      }
      
      .legal-table td em {
        color: #555;
        font-style: italic;
      }
      
      /* Responsive table for smaller screens */
      @media print {
        table {
          page-break-inside: avoid;
        }
        
        table td {
          padding: 4pt 8pt;
        }
      }
    </style>
  `;

  return (
    <div className="preview-modal-overlay">
      <div className="preview-modal-content">
        <div className="preview-padding-bg">
          <div className="preview-frame-wrapper">
            <iframe
              className="preview-frame"
              sandbox="allow-same-origin allow-scripts"
              srcDoc={`${documentStyles}${processedHtml}`}
              title="Document Preview"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
